export default __webpack_public_path__ + "static/media/goeei.ce7d370e.png";